import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.compass_full
import kotlin.time.Duration
import kotlin.time.Duration.Companion.milliseconds

@Composable
fun CompassDivider(
    modifier: Modifier = Modifier,
    isExpanded: Boolean,
    duration: Duration = 800.milliseconds,
    linesColor: Color? = null,
) = BoxWithConstraints {
    val maxLineWidth = maxWidth / 2 - 58.dp

//    val lineWidth by animateDpAsState(
//        targetValue = if (isExpanded) maxLineWidth else 0.dp,
//        animationSpec = tween(duration.inWholeMilliseconds.toInt()),
//        label = "lineWidth"
//    )

//    val rotation by animateFloatAsState(
//        targetValue = if (isExpanded) 180f else 0f,
//        animationSpec = tween(duration.inWholeMilliseconds.toInt()),
//        label = "rotation"
//    )

    Row(
        modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(Modifier.width(maxLineWidth)) {
            HorizontalDivider(
                Modifier.fillMaxWidth(),
                thickness = Dp.Hairline,
                color = linesColor ?: MaterialTheme.colorScheme.primary
            )
        }

        Spacer(Modifier.width(8.dp))

        Image(
            painter = painterResource(Res.drawable.compass_full),
            contentDescription = null,
            modifier = Modifier
                .size(42.dp)
//                .rotate(rotation)
        )

        Spacer(Modifier.width(8.dp))

        Box(Modifier.width(maxLineWidth)) {
            HorizontalDivider(
                Modifier.fillMaxWidth(),
                thickness = Dp.Hairline,
                color = linesColor ?: MaterialTheme.colorScheme.primary
            )
        }
    }
}